// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OFtb","newExpiryDate":"styles_newExpiryDate__GJmwf","footer":"styles_footer__DnB3l"};